import ButtonComponent from "../../components/buttonComponent";
import RefreshIcon from '@mui/icons-material/Refresh';

const MatTableHeader = (props) => {
    const {getTableData} = props;
    return (
        <>
            <div className="flex pt-4 flex-nowrap space-x-2 w-full pl-2 mr-0 justify-between">
                <h6 className="pt-3 font-bold rounded-sm">Freight Quotes</h6>
                <ButtonComponent
                    handleFunction={getTableData}
                    tooltip={"Refresh Data"}
                    variant={null}
                >
                    <RefreshIcon style={{ fontSize: '20px' }} />
                </ButtonComponent>
            </div>
        </>

    );
};

export default MatTableHeader
